import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useEnterpriseTheme } from "@/enterprise/theme/ThemeProvider";
import { useEnterpriseAuth } from "@/enterprise/hooks/useEnterpriseAuth";

export default function EnterpriseShell() {
  const loc = useLocation();
  const theme = useEnterpriseTheme();
  const { realmId, orgId, role } = useEnterpriseAuth();

  return (
    <div className={`min-h-screen text-white bg-gradient-to-b ${theme.glassTint}`}>
      <header className={`sticky top-0 z-20 border-b ${theme.accentBorder} backdrop-blur bg-black/40`}>
        <div className="mx-auto max-w-7xl px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className={`h-6 w-6 rounded-lg border ${theme.accentBorder} shadow`} />
            <div className="font-semibold tracking-wide">
              SynkTribe <span className="opacity-60 capitalize">{realmId || "enterprise"}</span>
            </div>
          </div>
          <div className="text-xs opacity-70">
            org: <span className="font-mono">{orgId ?? "—"}</span> • role: <span className="font-mono">{role ?? "—"}</span>
          </div>
        </div>
      </header>

      <div className="mx-auto max-w-7xl px-4 py-6 grid grid-cols-1 lg:grid-cols-[220px_1fr] gap-6">
        <nav className="self-start lg:sticky lg:top-[72px]">
          <div className={`rounded-2xl border ${theme.accentBorder} bg-white/5 p-2`}>
            {[
              ["", "Home"],
              ["devices", "Devices"],
              ["analytics", "Analytics"],
              ["members", "Members"],
              ["settings", "Settings"],
              ["privacy", "Privacy"],
            ].map(([to, label]) => {
              const active =
                loc.pathname === "/enterprise" && to === "" ? true : loc.pathname.startsWith(`/enterprise/${to}`);
              return (
                <NavLink
                  key={to}
                  to={`/enterprise${to ? `/${to}` : ""}`}
                  className={`block w-full text-left px-3 py-2 rounded-xl mb-1 border transition ${
                    active ? "bg-white/10 border-white/20" : "border-transparent hover:bg-white/5"
                  }`}
                >
                  {label}
                </NavLink>
              );
            })}
          </div>
        </nav>

        <main className="pb-24">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
